import { ApiRoute, ReferralStats, ReferralStatsSchema, getApiRoute } from "@garther/interfaces";

import { API_BASE_URL } from "../configs";
import { BaseApiClient } from "./base-client";

export class ReferralApiClient extends BaseApiClient {
  constructor() {
    super({
      baseURL: API_BASE_URL,
      baseEndpoint: getApiRoute(ApiRoute.REFERRAL),
      requireAuth: true
    });
  }

  async getStats(orgId?: string): Promise<ReferralStats | null> {
    try {
      return await this.get(orgId ? `org/${orgId}/stats` : "me/stats", ReferralStatsSchema, {
        requireAuth: true
      });
    } catch (error) {
      return null;
    }
  }
}

// Create and export the referral API client instance
export const referralApiClient = new ReferralApiClient();
